import { invert } from 'lodash-es';
import { caseSectionTabs } from '@features/store/case-section-tabs.store';

export const DEFAULT_CASE_TAB_PATH = 'details';
export const DEFAULT_CASE_TAB_KEY = caseSectionTabs.DETAILS;

export const CASE_PATH_TO_TAB = {
  details: caseSectionTabs.DETAILS,
  resources: caseSectionTabs.RESOURCES,
  clinical: caseSectionTabs.CLINICAL,
  log: caseSectionTabs.LOG,
  access: caseSectionTabs.ACCESS,
  'location-tracking': caseSectionTabs.LOCATION_TRACKING,
} as const;

export const CASE_TAB_TO_PATH = invert(CASE_PATH_TO_TAB) as Record<string, string>;
